// extracted by mini-css-extract-plugin
export var brand = "_2e-9";
export var compact = "_2e-6";
export var extraSmall = "_2e-7";
export var icon = "_2e-0";
export var large = "_2e-4";
export var light = "_2e-1";
export var medium = "_2e-5";
export var outline = "_2e-b";
export var primaryDark = "_2e-a";
export var primaryLight = "_2e-8";
export var primaryModern = "_2e-c";
export var success = "_2e-2";
export var successSolid = "_2e-3";